// extracted by mini-css-extract-plugin
export default {"recos":"y4-z","productCardOverride":"z4-z","rowHasBadge":"A4-z"};